import {
	PersonnelDetail,
	PersonnelDetailGeneralInformation,
} from './personnel-detail.models';
import { FieldWorker, FieldWorkerPerDiemAgreementType } from 'src/shared/api';
import { FieldWorkerTypeId } from 'src/shared/constants';

export function personnelFormToFieldWorker(
	formValue: PersonnelDetail
): Required<FieldWorker> {
	let personnel: Required<FieldWorker>;
	if (formValue) {
		const { unavailableDays, company, ...details } = formValue;

		personnel = {
			unavailableDays,
			company,
			...details.generalInfo,
		};
	}
	return personnel;
}

export function fieldWorkerToPersonnelForm(
	personnel: FieldWorker
): PersonnelDetail | null {
	if (personnel) {
		return {
			generalInfo: personnelToGeneralInfo(personnel),
			company: personnel.company,
			unavailableDays: personnel.unavailableDays || [],
		};
	} else {
		return {
			generalInfo: null,
			company: null,
			unavailableDays: [],
		};
	}
}

function personnelToGeneralInfo(
	personnel: FieldWorker
): PersonnelDetailGeneralInformation {
	return {
		id: personnel.id,
		team: personnel.team,
		firstName: personnel.firstName,
		lastName: personnel.lastName,
		jobTitle: personnel.jobTitle,
		type: personnel.type,
		status: personnel.status,
		employeeCode: personnel.employeeCode,
		paycomId: personnel.paycomId,
		statedLivedIn: personnel.statedLivedIn,
		cityLivedIn: personnel.cityLivedIn,
		perDiemAgreementType: personnel.perDiemAgreementType,
		regularHourlyRate: personnel.regularHourlyRate,
		payrollType: personnel.payrollType,
		utilityTravelOverrideRate: personnel.utilityTravelOverrideRate,
		isExcludedFromPayroll: personnel.isExcludedFromPayroll,
		mealBreakAttestationSigned: personnel.mealBreakAttestationSigned,
		language: personnel.language
	};
}

export const displayAgreementType: {
	[K in keyof typeof FieldWorkerPerDiemAgreementType]: string;
} = {
	A: 'A',
	B: 'B',
	C: 'C',
};

// "Actual" meaning those who are in the field and not field support.
export const actualFieldWorkerTypeIds = [
	FieldWorkerTypeId.RwicTypeId,
	FieldWorkerTypeId.ManagerTypeId,
	FieldWorkerTypeId.SupervisorTypeId,
];
